import { render, staticRenderFns } from "./WalletIndexView.vue?vue&type=template&id=777f358f&scoped=true"
import script from "./WalletIndexView.vue?vue&type=script&lang=js"
export * from "./WalletIndexView.vue?vue&type=script&lang=js"
import style0 from "./WalletIndexView.vue?vue&type=style&index=0&id=777f358f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f358f",
  null
  
)

export default component.exports